import { AccountMetadata } from "@/reducers/environments";
import { EnvironmentID } from "@/types/global";
import { makeRequest } from "@/util";

export const RoleAdmin = "admin";
export const RoleInviteDefault = "user";

// Granting every environment is what the Team page already sends for a
// non-admin invite where the inviter didn't pick environments explicitly.
export function allEnvironmentIDs(
  accountMetadata: AccountMetadata,
): EnvironmentID[] {
  return accountMetadata.projects.flatMap((project) =>
    project.environments
      .map((environment) => environment.ID)
      .filter((id): id is EnvironmentID => !!id),
  );
}

export function inviteUser({
  email,
  role,
  envIDs,
}: {
  email: string;
  role: string;
  envIDs: EnvironmentID[];
}) {
  return makeRequest("invite_user", {
    email,
    role,
    user_envs: envIDs.map((envID) => ({ env_id: envID })),
  });
}
